import { Box } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import MobileSidebar from "./mobile-drawer";
import { NavItems } from "./nav-items";
import AppBar from "./app-bar";

export const Layout: React.FC = () => {
  return (
    <Box display={"flex"} flexDirection={{ xs: "column", md: "row" }}>
      {/* desktop sidebar */}
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <NavItems />
      </Box>

      {/* mobile sidebar */}
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <MobileSidebar />
      </Box>

      {/* pages content */}
      <Box flexGrow={1} minWidth={0}>
        <AppBar />
        <Outlet />
      </Box>
    </Box>
  );
};
